
export default function ShowcaseSection() {
  const platforms = [
    {
      title: 'YouTube Shorts & Long-Form Video',
      description: 'Engaging video content optimized for YouTube\'s algorithm and audience preferences',
      icon: 'ri-youtube-line',
      color: 'from-red-500 to-red-600',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/1ad07cf407c23a50a537f2503b0f2e88.png'
    },
    {
      title: 'TikTok Growth & Creator Partnerships',
      description: 'Viral TikTok strategies and influencer collaborations to reach younger demographics',
      icon: 'ri-music-line',
      color: 'from-pink-500 to-purple-600',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/34393e883d78c840cc65bf5d3c27483e.png'
    },
    {
      title: 'Instagram Reels',
      description: 'Creative Instagram Reels that drive engagement and build brand awareness',
      icon: 'ri-instagram-line',
      color: 'from-purple-500 to-pink-500',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/06f91511391847b7ccdb97974116455f.png'
    },
    {
      title: 'X Buzz',
      description: 'Strategic Twitter/X campaigns that generate conversations and trending topics',
      icon: 'ri-twitter-x-line',
      color: 'from-gray-700 to-gray-900',
      image: 'https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/24899e85f3d20d4d3c722a8fd32bcf03.png'
    }
  ];

  return (
    <section id="showcase" className="py-20 bg-gradient-to-br from-gray-50 via-amber-50/20 to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-yellow-500 to-amber-700">Showcase</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-600 mx-auto mb-8 shadow-sm"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Amplifying your brand across all major social media platforms with <span className="text-amber-700 font-semibold">creative content</span> and strategic campaigns
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {platforms.map((platform, index) => (
            <div key={index} className="group bg-gradient-to-br from-white via-amber-50/30 to-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105 border border-amber-100/30 hover:border-amber-200/50">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-100/10 to-yellow-100/10 rounded-t-xl"></div>
                <img 
                  src={platform.image}
                  alt={platform.title}
                  className="relative w-full h-48 object-cover object-top border-b border-amber-100/50"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="relative mr-4">
                    <div className="absolute inset-0 bg-gradient-to-br from-amber-200/30 to-yellow-200/30 rounded-lg transform scale-110"></div>
                    <div className={`relative w-12 h-12 bg-gradient-to-r ${platform.color} rounded-lg flex items-center justify-center shadow-lg`}>
                      <i className={`${platform.icon} text-white text-xl`}></i>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-amber-800 transition-colors">
                    {platform.title.includes('YouTube') ? (
                      <>
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold">YouTube</span> Shorts & Long-Form Video
                      </>
                    ) : platform.title.includes('TikTok') ? (
                      <>
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold">TikTok</span> Growth & Creator Partnerships
                      </>
                    ) : platform.title.includes('Instagram') ? (
                      <>
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold">Instagram</span> Reels
                      </>
                    ) : platform.title.includes('X Buzz') ? (
                      <>
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold">X</span> Buzz
                      </>
                    ) : (
                      platform.title
                    )}
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {platform.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="relative bg-gradient-to-br from-white via-amber-50/40 to-white rounded-2xl p-8 border border-amber-100/50 shadow-lg">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-100/10 to-yellow-100/10 rounded-2xl transform -rotate-1"></div>
            <div className="relative">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Ready to Go <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600">Viral?</span>
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
                Let our <span className="text-amber-700 font-semibold">creative team</span> develop engaging content that resonates with your audience across all platforms.
              </p>
              <button 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all duration-300 hover:transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-rocket-line mr-2"></i>
                Start Your <span className="font-bold">Premium</span> Campaign
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
